export enum BudgetSummaryStatus {
    /**
     * The budget is beneath the warning threshold
     */
    ON_TRACK = 'ON_TRACK',
    /**
     * The budget is above the warning threshold but has not exceeded the limit
     */
    AT_RISK = 'AT_RISK',
    /**
     * The budget is above the limit
     */
    OVER = 'OVER'
}
